import {GraphVersions, JoinType, TestType} from 'quantum-graph';
import {LATEST_YEAR, POMDatasets} from './datasets';
import {QueryObj} from '../../../../lib/data-types';

export function buildMdcQuery(regionType: string, metricType: string, region: string, fields: Array<string>): QueryObj {
    const dataset = regionType === 'msa' ? POMDatasets.MsaMdc : POMDatasets.StateMdc;
    const regionField = regionType === 'msa' ? 'msa_division' : 'state_fips';

    return {
        version: GraphVersions.V2,
        baseQueryGraph: {
            baseQuery: {
                queryType: 'dim',
                tableNodes: [
                    {
                        id: 'pom',
                        dataset,
                        columns: ['mdc', 'mdc_desc', ...(regionType === 'msa' ? ['msa_division', 'msa_division_name'] : []), ...fields],
                    }
                ],
            },
            joins: regionType === 'msa' ? [] : [{
                node: {
                    baseQuery: {
                        queryType: 'dim',
                        tableNodes: [{id: 'state', dataset: 'state', columns: ['state']}]
                    }
                },
                joinType: JoinType.Left,
                joinNodeId: 'pom',
            }],
        },
        sort: [{
            column: {nodeId: 'pom', column: 'mdc'},
            asc: true,
        }],
        filters: [
            {
                column: {nodeId: 'pom', column: 'metric_type'},
                test: TestType.Eq,
                value: metricType,
            },
            {
                column: {nodeId: 'pom', column: 'year_key'},
                test: TestType.Eq,
                value: LATEST_YEAR,
            },
            {
                column: {nodeId: 'pom', column: regionField},
                test: TestType.Eq,
                value: region,
            },
            {
                column: {nodeId: 'pom', column: 'under_age_65_pop'},
                test: TestType.NotNull,
                value: 0,
            },
        ],
    };
}
